<template>
  <div class="warp-box">
    <span @click="clickFn(item)" class="jump">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '去跳转',
    },
    clickFn: {
      type: Function,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.warp-box {
  padding-left: 20px;
}
.jump {
  color: #2e7eff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
